import { render, staticRenderFns } from "./employeesForm.vue?vue&type=template&id=4e1383b8&scoped=true&"
import script from "./employeesForm.vue?vue&type=script&lang=js&"
export * from "./employeesForm.vue?vue&type=script&lang=js&"
import style0 from "./employeesForm.vue?vue&type=style&index=0&id=4e1383b8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1383b8",
  null
  
)

export default component.exports